import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
//Conoce computos
import { QueSonComputosComponent } from './components/conoce-computos/que-son-computos/que-son-computos.component';
import { OperacionComputosComponent } from './components/conoce-computos/operacion-computos/operacion-computos.component';
import { NavegacionComputosComponent } from './components/conoce-computos/navegacion-computos/navegacion-computos.component';

//Elecciones federales
import { CargosElegiranComponent } from './components/elecciones-federales/cargos-elegiran/cargos-elegiran.component';
import { NormatividadComponent } from './components/elecciones-federales/normatividad/normatividad.component';
import { TipoCasillasComponent } from './components/elecciones-federales/tipo-casillas/tipo-casillas.component';

//Actas
import { CatalogoObservacionesComponent } from './components/actas/catalogo-observaciones/catalogo-observaciones.component';
import { PorcentajeActasComponent } from './components/actas/porcentaje-actas/porcentaje-actas.component';

//Otros
import { GlosarioComponent } from './components/glosario/glosario.component';
import { PreguntasFrecuentesComponent } from './components/preguntas-frecuentes/preguntas-frecuentes.component';
import { HeaderComponent } from './components/shared/header/header.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { RedesSocialesComponent } from './components/shared/redes-sociales/redes-sociales.component';
import { OtroInteresComponent } from './components/shared/otro-interes/otro-interes.component';
import { BuscadorComponent } from './components/shared/buscador/buscador.component';


//Redes Sociales
import { ShareModule } from '@ngx-share/core';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';


//Rutas
import { APP_ROUTING } from './app.routes';

//Pipe
import { BuscarPipe } from './pipe/buscar.pipe';
//Servicios
import { BuscarService } from './services/buscar.service';
import { MenuService } from './services/menu.service';
import { MapaService } from './services/mapa.service';
import { AcercaVotoComponent } from './components/elecciones-federales/acerca-voto/acerca-voto.component';
import { CircunscripcionesComponent } from './components/elecciones-federales/circunscripciones/circunscripciones.component';

@NgModule({
  declarations: [
    AppComponent,
    QueSonComputosComponent,
    OperacionComputosComponent,
    NavegacionComputosComponent,
    CargosElegiranComponent,
    NormatividadComponent,
    TipoCasillasComponent,
    GlosarioComponent,
    PreguntasFrecuentesComponent,
    HeaderComponent,
    FooterComponent,
    RedesSocialesComponent,
    OtroInteresComponent,
    BuscadorComponent,
    CatalogoObservacionesComponent,
    PorcentajeActasComponent,
    BuscarPipe,
    AcercaVotoComponent,
    CircunscripcionesComponent
  ],
  imports: [
    BrowserModule,
    APP_ROUTING,
    HttpModule,
    HttpClientModule,
    HttpClientJsonpModule,
    ShareModule.forRoot(),
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    BuscarService,
    MenuService,
    MapaService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts